/* eslint-disable complexity */
import React from 'react';

import { Amount } from './amount';
import { EndAfterRepeatCount } from './end-after-repeat-count';
import { EndDate } from './end-date';
import { EndDateType, IncreaseDecreaseRepeating, PredictionHeaderProps } from '../../../types';
import { EndType } from './end-type';
import { IncreaseDecreaseAmount } from './increase-decrease-amount';
import { IncreaseDecreasePercentage } from './increase-decrease-percentage';
import { IncreaseDecreaseType } from './increase-decrease-type';
import { RepeatingMethodState } from '../types';
import { RepeatPattern } from './repeat-pattern';
import { StartDate } from './start-date';

export interface RepeatingMethodTopBarProps {
  currencySymbol: string;
  data: RepeatingMethodState;
  onEndDateChange: (date: Date) => void;
  onEndDateTypeChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onEndsAfterChange: (value: string) => void;
  onIncreaseDecreaseAmountChange: (value: string) => void;
  onIncreaseDecreaseRepeatingTypeChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onRepeatingAmountChange: (value: string) => void;
  onRepeatingPatternChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onStartDateChange: (date: Date) => void;
  PredictionHeader: React.FunctionComponent<PredictionHeaderProps>;
}

export const RepeatingMethodTopBar = ({
  currencySymbol,
  data,
  onEndDateChange,
  onEndDateTypeChange,
  onEndsAfterChange,
  onIncreaseDecreaseAmountChange,
  onIncreaseDecreaseRepeatingTypeChange,
  onRepeatingAmountChange,
  onRepeatingPatternChange,
  onStartDateChange,
  PredictionHeader
}: RepeatingMethodTopBarProps) => {
  const endAfterRepeatCount =
    typeof data.end_after_repeat_count === 'number'
      ? String(data.end_after_repeat_count)
      : data?.end_after_repeat_count || '';

  const increaseDecreaseFixedAmount =
    typeof data.increase_decrease_fixed_amount === 'number'
      ? String(data.increase_decrease_fixed_amount || '')
      : data.increase_decrease_fixed_amount || '';

  const increaseDecreaseFixedPercentage =
    typeof data.increase_decrease_percentage === 'number'
      ? String(data.increase_decrease_percentage || '')
      : data.increase_decrease_percentage || '';

  return (
    <PredictionHeader wrap>
      <StartDate onChange={onStartDateChange} value={data.start_date} />
      <Amount currencySymbol={currencySymbol} onChange={onRepeatingAmountChange} value={String(data.amount)} />
      <RepeatPattern onChange={onRepeatingPatternChange} value={data.repeat_pattern} />

      <EndType onChange={onEndDateTypeChange} value={data.end_type} />
      {data.end_type === EndDateType.end_after && (
        <EndAfterRepeatCount onChange={onEndsAfterChange} value={endAfterRepeatCount} />
      )}
      {data.end_type === EndDateType.end_on_date && (
        <EndDate onChange={onEndDateChange} startDate={data.start_date} value={data.end_on_date} />
      )}

      <IncreaseDecreaseType
        onChange={onIncreaseDecreaseRepeatingTypeChange}
        repeatPattern={data.repeat_pattern}
        value={data.increase_decrease_type}
      />
      {data.increase_decrease_type === IncreaseDecreaseRepeating.increaseDecreaseByAmount && (
        <IncreaseDecreaseAmount
          currencySymbol={currencySymbol}
          onChange={onIncreaseDecreaseAmountChange}
          value={increaseDecreaseFixedAmount}
        />
      )}
      {data.increase_decrease_type === IncreaseDecreaseRepeating.increaseDecreaseByPercentage && (
        <IncreaseDecreasePercentage onChange={onIncreaseDecreaseAmountChange} value={increaseDecreaseFixedPercentage} />
      )}
    </PredictionHeader>
  );
};
